export default __webpack_public_path__ + "static/media/repair-4.7f7240d0.jpg";